// extracted by mini-css-extract-plugin
export var boxItems = "_av-1";
export var boxItemsLg = "_av-2";
export var button = "_av-7";
export var buttonHoverless = "_av-9";
export var buttonLg = "_av-8";
export var filterGroupBox = "_av-0";
export var icon = "_av-3";
export var iconSecondary = "_av-6";
export var iconWrapper = "_av-4";
export var iconWrapperLg = "_av-5";
export var truncatedLabel = "_av-a";